import { STORE_MODULE_NAME } from "./measurementTypeStoreModule";

export default function useMeasurementType() {

  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {
    fetchDataUrl,
  }
}
